<template>
  <article class="procedure">
    <confirm title="您修改了“手续信息”，是否需要保存？" cancelText="取消" confirmText="保存" v-model="show" @on-cancel="onCancel" @on-confirm="onConfirm">
    </confirm>
    <group>
      <x-input title="过户要求" v-model="procedureInfo.transferRequest" placeholder="请输入">
        <span slot="right" class="fc-block">天</span>
      </x-input>
      <selector title="购置税" placeholder="请选择" v-model="procedureInfo.purchaseTax" :options="purchaseTaxList"></selector>
      <cell>
        <span class="weui_label" slot="icon">行驶证</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.drivingLicense" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in drivingLicenseList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <cell>
        <span class="weui_label" slot="icon">登记证</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.registration" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in registrationList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <datetime class="time-picker" v-model="procedureInfo.annualDue" confirm-text="完成" cancel-text="取消" :min-year=1970 format="YYYY-MM-DD" placeholder="请选择" title="年检到期日"></datetime>
      <datetime class="time-picker" v-model="procedureInfo.strongInsurance" confirm-text="完成" cancel-text="取消" :min-year=1970 format="YYYY-MM-DD" placeholder="请选择" title="强险到期日"></datetime>

      <datetime class="time-picker" v-model="procedureInfo.commercialInsurance" confirm-text="完成" cancel-text="取消" :min-year=1970 format="YYYY-MM-DD" placeholder="请选择" title="商险到期日"  @on-clear="clearDate" clear-text="无商险"></datetime>
      <cell>
        <span class="weui_label" slot="icon">新车发票</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.carInvoice" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in carInvoiceList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <cell>
        <span class="weui_label" slot="icon">新车质保</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.carWarranty" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in carWarrantyList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <x-input title="钥匙" v-model="procedureInfo.key" placeholder="请输入">
        <span slot="right" class="fc-block">把</span>
      </x-input>
      <cell>
        <span class="weui_label" slot="icon">保养手册</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.maintenanceManual" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in maintenanceManualList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <cell>
        <span class="weui_label" slot="icon">说明书</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.instructions" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in instructionsList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <cell>
        <span class="weui_label" slot="icon">未处理违章</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.unHandleIllegal" default-item-class="carColorChange-item" selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in unHandleIllegalList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
<!--       <x-input title="过户次数" v-model="procedureInfo.transferTimes" placeholder="请输入">
        <span slot="right" class="fc-block">次</span>
      </x-input> -->
      <cell>
        <span class="weui_label" slot="icon">过户票</span>
        <div slot="after-title">
          <checker v-model="procedureInfo.transferTickets" default-item-class="carColorChange-item"
                   selected-item-class="carColorChange-item-selected">
            <checker-item v-for="val in transferTicketsList" :value="val" :key="val">{{val}}</checker-item>
          </checker>
        </div>
      </cell>
      <selector placeholder="请选择" title="迁往何处" v-model="procedureInfo.newPlace" :options="newPlaceList"></selector>
      <div v-if="procedureInfo.newPlace==1" class="line-border">
        <selector placeholder="请选择" title="过户费" v-model="procedureInfo.transferFee" :options="transferFeeList"></selector>
      </div>
      <div v-else-if="procedureInfo.newPlace==2" class="line-border">
        <selector placeholder="请选择" title="运费" v-model="procedureInfo.freight" :options="freightList"></selector>
        <selector placeholder="请选择" title="提档费" v-model="procedureInfo.mentionFee" :options="mentionFeeList"></selector>
      </div>
      <div v-else-if="procedureInfo.newPlace==3" class="line-border">
        <selector placeholder="请选择" title="过户费" v-model="procedureInfo.transferFee" :options="transferFeeList"></selector>
        <selector placeholder="请选择" title="运费" v-model="procedureInfo.freight" :options="freightList"></selector>
        <selector placeholder="请选择" title="提档费" v-model="procedureInfo.mentionFee" :options="mentionFeeList"></selector>
      </div>
      <selector placeholder="请选择" title="手续补办费用" v-model="procedureInfo.proceduresSpend" :options="proceduresSpendList"></selector>
    </group>
    <Footer-btn title="保存手续信息" @submit="toSave('remark')"></Footer-btn>
  </article>
</template>

<script>
// 车辆信息(手续信息)
import {
  Cell,
  Selector,
  XInput,
  Group,
  Checker,
  CheckerItem,
  Confirm,
  Datetime
} from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import { procedure } from './restConfig'
export default {
  components: {
    FooterBtn,
    Cell,
    Selector,
    XInput,
    Group,
    Checker,
    CheckerItem,
    Confirm,
    Datetime
  },
  props: {
    source: String,
    id: [String, Number],
    configInfo: Array,
    procedureInfo: Object,
    configIsReady: Boolean,
    procedureIsReady: Boolean
  },
  data() {
    return {
      show: false, // 是否显示弹窗
      originProcedureInfo: {},
      nextPage: '', // 下个页面
      purchaseTaxList: [
        {
          key: '1',
          value: '已征收'
        }, {
          key: '2',
          value: '未征收'
        }, {
          key: '1',
          value: '无'
        }],
      drivingLicenseList: ['有', '无'],
      registrationList: ['有', '无'],
      carInvoiceList: ['有', '无'],
      carWarrantyList: ['保内', '过保'],
      maintenanceManualList: ['有', '无'],
      instructionsList: ['有', '无'],
      unHandleIllegalList: ['有', '无'],
      transferTicketsList: ['有', '无'],
      proceduresSpendList: [
        {
          key: '1',
          value: '买方承担'
        },
        {
          key: '2',
          value: '卖方承担'
        },
        {
          key: '3',
          value: '无'
        }
      ],
      transferFeeList: [
        {
          key: '1',
          value: '买方承担'
        },
        {
          key: '2',
          value: '卖方承担'
        }
      ],
      freightList: [
        {
          key: '1',
          value: '买方承担'
        },
        {
          key: '2',
          value: '卖方承担'
        }
      ],
      mentionFeeList: [
        {
          key: '1',
          value: '买方承担'
        },
        {
          key: '2',
          value: '卖方承担'
        }
      ],
      newPlaceList: [
        {
          key: '1',
          value: '本市'
        },
        {
          key: '2',
          value: '外迁'
        },
        {
          key: '3',
          value: '本市外迁均可'
        }
      ]
    }
  },
  created() {
    this.id = this.$route.params.id
    this.originProcedureInfo = Object.assign({}, this.procedureInfo)
  },
  methods: {
    clearDate() {
      this.procedureInfo.commercialInsurance = '无商险'
    },
    inspectionEveryPops() {
      let procedure = this.procedureInfo
      for (let k in procedure) {
        if (k !== 'newPlace' && k !== 'transferFee' && k !== 'freight' && k !== 'mentionFee' && k !== 'lastTransferDate' && k !== 'commercialInsurance') {
          if (procedure[k] === '' || procedure[k].length <= 0) {
            return false
          }
        } else {
          let newPlace = procedure['newPlace']
          if (newPlace === '') {
            return false
          } else {
            let transferFee = procedure['transferFee'] // 过户费
            let freight = procedure['freight'] // 运费
            let mentionFee = procedure['mentionFee'] // 提档费
            if (newPlace === '1' && transferFee === '') {
              return false
            } else if (newPlace === '2' && mentionFee === '' && freight === '') {
              return false
            } else if (newPlace === '3' && transferFee === '' && freight === '' && mentionFee === '') {
              return false
            }
          }
        }
      }
      return true
    },
    toSave(nextPage) {
      let key = this.procedureInfo.key
      if (key && !/^[0-9]*[1-9][0-9]*$/.test(key)) {
        this.showToast('请输入正确的钥匙数量')
        return false
      }
      // let transferTimes = this.procedure.transferTimes
      // if (!/^\+?(0|[1-9][0-9]*)$/.test(transferTimes)) {
      //   this.showToast('请输入正确的过户次数')
      //   return false
      // }
      let newPlace = this.procedureInfo['newPlace']
      if (newPlace === '1') {
        this.procedureInfo['freight'] = ''
        this.procedureInfo['mentionFee'] = ''
      } else if (newPlace === '2') {
        this.procedureInfo['transferFee'] = ''
      }
      // 数据是否完整
      const procedureIsReady = this.inspectionEveryPops()
      // if (!procedureIsReady) {
      //   this.showToast('数据未填写完整')
      //   return false
      // }
      let url = procedure.saveProcedure[this.source](this.id)
      this.$rest.carInfo.create({
        info: JSON.stringify({
          config: this.configInfo,
          config_is_ready: this.configIsReady,
          procedure: this.procedureInfo,
          procedure_is_ready: procedureIsReady
        })
      }, url).then(res => {
        if (res.code === 0) {
          this.showToast('保存成功')
          this.$emit('update:procedureIsReady', procedureIsReady)
          // 同步数据
          this.$emit('on-after-save', nextPage)
        } else {
          this.nextPage = ''
          this.showToast(res.message)
        }
      })
    },
    goToAnother (nextPage) {
      let originProcedureInfo = this.originProcedureInfo
      this.nextPage = nextPage
      if (originProcedureInfo) {
        // 是否有改变表单
        this.show = Object.keys(originProcedureInfo).some(key => {
          return this.procedureInfo[key] !== originProcedureInfo[key]
        })
        if (!this.show) {
          this.$emit('on-after-save', nextPage)
        }
      } else {
        this.toSave(nextPage)
        // this.$router.push('/auction/carInfo/' + this.nextPage + '/' + this.id)
      }
    },
    onConfirm() {
      this.show = false
      this.toSave(this.nextPage)
    },
    onCancel() {
      this.$emit('on-after-save', this.nextPage)
    },
    hasChange() {
      let originProcedureInfo = this.originProcedureInfo
      return Object.keys(originProcedureInfo).some(key => {
        return this.procedureInfo[key] !== originProcedureInfo[key]
      })
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
  @import "../../../stylesheets/modules/manage/input.less";

  .line-border {
    position: relative;
    &:before {
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      border-top: 1px solid #D9D9D9;
      color: #D9D9D9;
      transform-origin: 0 0;
      transform: scaleY(0.5);
      left: 0.4rem;
    }
  }
</style>
